<template>
  <div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="tech_level"><div @click="select_level(level_item.id)" :class="['evaluate__tabTitle',level_active==level_item.id?'active':'']" v-for="(level_item,level_index) in tech_level" :key="level_index"><span>{{level_item.title}}</span></div></div>

      <div class="storeList flex_center" v-for="(techItem,techIndex) in techList" :key="techIndex">
        <!--技师头像-->
        <div class="tech__headBox" v-if="techItem.type=='2'">
          <img class="tech__headImg seniorTech" :src="techItem.thumb?techItem.thumb:techItem.avatar" alt />
          <img class="tech__head_crown" src="/static/img/crown_icon.png" alt />
        </div>
        <div class="tech__headBox" v-if="techItem.type=='1'">
          <img class="tech__headImg seniorTech seniorTech2" :src="techItem.thumb?techItem.thumb:techItem.avatar" alt />
          <img class="tech__head_crown" src="/static/img/crown_icon2.png" alt />
        </div>
        <div class="tech__headBox" v-if="techItem.type=='0'">
          <img class="tech__headImg" :src="techItem.thumb?techItem.thumb:techItem.avatar" alt />
        </div>
        <!--技师内容-->
        <div class="storeList__content">
          <div class="flex_center techList__title">
            <span>{{techItem.name}}</span>
            <div class="detail_star">
              <span v-for="(item,index) in 5" :key="index">
                <van-icon class="star" size="15px" name="star" v-if="techItem.score > index" :color="star_active" />
                <van-icon class="star" size="15px" name="star" v-else/>
              </span>
            </div>
          </div>
          <div class="col_999 fs_12">
            <p>{{techItem.levelname}}</p>
            <div class="flex techList__line">
              <div>个人编号：{{techItem.num_id}}</div>
              <router-link :to="{ path: '/technicianDetails', query: { tech_id: techItem.id,store_id:store_id}}" class="techList__btn">立即预约</router-link>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
  export default {
    name: "technicianList",
    data(){
      return{
        star_active: "#F9CE06",   //星星
        //技师列表
        techList: [
          // {
          //   type:'2',
          //   headImg: '/static/img/tech_head2.png',
          //   name: '成技师',
          //   grade:'首席技师',
          //   star_level:5,
          //   perNum:"1234444222"
          // },{
          //   type:'1',
          //   headImg: '/static/img/tech_head1.png',
          //   name: '成技师',
          //   grade:'资深技师',
          //   star_level:5,
          //   perNum:"1234444222"
          // },{
          //   type:'0',
          //   headImg: '/static/img/tech_head1.png',
          //   name: '成技师',
          //   grade:'技师',
          //   star_level:4,
          //   perNum:"1234444222"
          // },{
          //   type:'0',
          //   headImg: '/static/img/tech_head1.png',
          //   name: '成技师',
          //   grade:'技师',
          //   star_level:5,
          //   perNum:"1234444222"
          // },
        ],
        loading:false,
        finished:true,
        tech_level:[],
        level_active:0,
        service_id:0,
        store_id:0,
        
      }
    },
  
    created(){
      this.service_id = this.$route.query.service_id;
      this.store_id = this.$route.query.store_id;
      this.level_active = this.$route.query.level_id;
      this.get_tech();
    },
    methods: {
      onLoad() {
        // 异步更新数据

      },
      select_level(level_id){
          this.level_active = level_id;
          this.get_tech();
      },
      get_tech(){
        this.axios({
          url: this.api.tech.get_tech_list,
          data:{
            'select_level':this.level_active,
            'service_id':this.service_id
          }
      }).then((res) => {
          if (res.error === 0) {
            this.techList  = res.tech_list     
            this.tech_level = res.tech_level
            this.level_active = res.select_level      
          }

      })
      }
    },
  }
</script>

<style scoped>
  @import '../../../assets/css/store.css';
  @import '../../../assets/css/technician.css';
  .tech_level{
      background: white;
      /* margin-top: 0.2rem; */
      overflow: hidden;
      text-align: center;
      /* margin: 0.5rem 0; */
      margin-bottom: 0.5rem;

  }
  .evaluate__tabTitle{
      color: #999;
      border: 1px solid #ccc;
      line-height: 1.2rem;
      margin: .45rem .1rem;
      border-radius: 1.2rem;
      font-size: .6rem;
      display: inline-block;
      margin-left: 0.5rem;
  }
  .evaluate__tabTitle span{
    padding: 0.5rem;
  }
  .active {
    color: #45B9BC;
    border-color: rgba(69, 185, 188, .5);
  }
</style>



// WEBPACK FOOTER //
// src/views/book/technician/technicianList.vue